"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timezone = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.Timezone = {
    AmericaLosAngeles: 'America/Los_Angeles',
    AmericaDenver: 'America/Denver',
    AmericaChicago: 'America/Chicago',
    AmericaNewYork: 'America/New_York',
    AmericaAdak: 'America/Adak',
    AmericaYakutat: 'America/Yakutat',
    AmericaJuneau: 'America/Juneau',
    AmericaSitka: 'America/Sitka',
    AmericaMetlakatla: 'America/Metlakatla',
    AmericaAnchorage: 'America/Anchorage',
    AmericaNome: 'America/Nome',
    AmericaPhoenix: 'America/Phoenix',
    PacificHonolulu: 'Pacific/Honolulu',
    AmericaBoise: 'America/Boise',
    AmericaIndianaMarengo: 'America/Indiana/Marengo',
    AmericaIndianaVincennes: 'America/Indiana/Vincennes',
    AmericaIndianaTellCity: 'America/Indiana/Tell_City',
    AmericaIndianaPetersburg: 'America/Indiana/Petersburg',
    AmericaIndianaKnox: 'America/Indiana/Knox',
    AmericaIndianaWinamac: 'America/Indiana/Winamac',
    AmericaIndianaVevay: 'America/Indiana/Vevay',
    AmericaKentuckyLouisville: 'America/Kentucky/Louisville',
    AmericaIndianaIndianapolis: 'America/Indiana/Indianapolis',
    AmericaKentuckyMonticello: 'America/Kentucky/Monticello',
    AmericaMenominee: 'America/Menominee',
    AmericaNorthDakotaCenter: 'America/North_Dakota/Center',
    AmericaNorthDakotaNewSalem: 'America/North_Dakota/New_Salem',
    AmericaNorthDakotaBeulah: 'America/North_Dakota/Beulah',
    AmericaPuertoRico: 'America/Puerto_Rico',
    AmericaStThomas: 'America/St_Thomas'
};
//# sourceMappingURL=timezone.js.map